var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sub-content-container',{attrs:{"title":_vm.$t('aboutMe.otherMerits.pageLabel')}},_vm._l((_vm.completeMerits),function(merit,i){return _c('merit',{key:("merit-" + i),attrs:{"merit":merit}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }